var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudiomoono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 687.59 65.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "studiomoono") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,43.32H9.19c.73,8.19,6.1,13.47,15.11,13.47,8,0,13.83-3.1,13.83-10C38.13,31.49,2,40.68,2,17.2,2,7,10.92,0,23.75,0c13,0,21.93,7.55,22.75,19.2H37.31c-.64-6.55-5.73-10.83-13.56-10.83-7.64,0-12.28,3.46-12.28,8.83,0,15.47,36.31,5.19,36.31,29.49,0,11.64-9.83,18.47-23.48,18.47C9.92,65.16.73,56.51,0,43.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.07,9.1H50.14V.73H99.46V9.1H79.53V64.43H70.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,42.13V.73h9.1V42.41c0,9.1,6.19,14.29,15.29,14.29s15.38-5.19,15.38-14.29V.73h9.1v41.4c0,14.57-9.83,23-24.48,23S105.74,56.7,105.74,42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35.73h19.56C203.66.73,218,11.83,218,32.58s-14.38,31.85-32.13,31.85H166.35Zm19,55.33c11.83,0,22.93-6.64,22.93-23.48S197.2,9.1,185.37,9.1h-9.56v47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,.73h9.47v63.7H228Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,32.58C247.52,13.83,261,0,279.18,0s31.58,13.83,31.58,32.58-13.47,32.58-31.58,32.58S247.52,51.33,247.52,32.58Zm53.6,0c0-13.92-9.29-24.21-21.94-24.21s-22,10.29-22,24.21,9.38,24.21,22,24.21S301.12,46.5,301.12,32.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72.73h11.65l20.29,50.78L415,.73H426.6v63.7h-9.1V17l-19,47.41h-7.64L371.73,17V64.43h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.61,32.58C436.61,13.74,448.9,0,467.19,0,486,0,491,14.74,495.22,14.74S504.23,0,523.06,0c18.3,0,30.58,13.74,30.58,32.58s-12.28,32.58-30.58,32.58c-18.83,0-23.75-14.74-27.93-14.74s-9.29,14.74-28,14.74C449.08,65.16,436.61,51.51,436.61,32.58Zm58.52,7.55c8.82,0,11.1,16.66,27.93,16.66C535.71,56.79,544,46.5,544,32.58S535.71,8.37,523.06,8.37c-16.83,0-19.11,16.57-27.93,16.57S484,8.37,467.19,8.37c-12.65,0-20.93,10.29-20.93,24.21s8.28,24.21,20.93,24.21C484,56.79,486.39,40.13,495.13,40.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.65.73H574.2l30.67,49.05V.73h9.47v63.7H603.87l-30.76-49v49h-9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.34,32.58C624.34,13.83,637.81,0,656,0s31.58,13.83,31.58,32.58S674.12,65.16,656,65.16,624.34,51.33,624.34,32.58Zm53.6,0c0-13.92-9.28-24.21-21.93-24.21s-22,10.29-22,24.21,9.37,24.21,22,24.21S677.94,46.5,677.94,32.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiomoono);
export default __webpack_public_path__ + "static/media/studiomoono.92b1cde939e1291206de3d378046c137.svg";
export { ForwardRef as ReactComponent };